import { Badge } from "@/components/ui/badge";
import { XCircle } from "lucide-react";

export const DeactivatedBadge = () => (
	<Badge
		variant="outline"
		className="gap-1 border-red-200 bg-red-50 px-1.5 py-0 text-[10px] font-medium text-red-600"
	>
		<XCircle className="h-3 w-3" />
		Deactivated
	</Badge>
);
